<!--
 * @Author: Ygm
 * @Date: 2024-08-07 14:46:30
 * @LastEditors: Ygm
 * @LastEditTime: 2024-08-07 16:10:14
 * @Description: 基础Tab
 -->
<script>
export default {
  name: 'BaseTab',
  props: {
    // tab数据
    data: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 样式类型
    tabType: {
      type: String,
      default: 'line'
    }
  }
}
</script>

<template>
  <a-tabs :type="tabType" class="header-tabs" @change="key => $emit('change', key)">
    <a-tab-pane v-for="tab in data" :key="tab.value" :tab="tab.name" />
  </a-tabs>
</template>

<style scoped lang="scss">
.header-tabs {
  /deep/ .ant-tabs-tab {
    font-size: 16px;
    user-select: none;
  }

  /deep/ .ant-tabs-tab:hover {
    color: #999;
  }

  /deep/ .ant-tabs-ink-bar {
    background-color: #4d7cfd;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BaseTab/index.vue